import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { FairValueEvaluationStatus, IFairValueEvaluationPeriod } from 'models/FairValueEvaluation'
import Select, { ISelectOption } from 'components/Select/Select'
import { Flex, FlexItem } from 'components/Flex'
import Text from 'components/Text/Text'
import FlexibleContent from 'components/FlexibleContent/FlexibleContent'
import StatusLight, { StatusLightType } from 'components/StatusLight/StatusLight'

interface IBookingPeriodsSelectProps {
    options: ISelectOption<IFairValueEvaluationPeriod>[]
    value: IFairValueEvaluationPeriod | null
    onChange: (value: IFairValueEvaluationPeriod) => void
}
export const periodStatusToIndicator = {
    "checked": StatusLightType.success,
    "notChecked": StatusLightType.error,
}
const BookingPeriodsSelect: FC<IBookingPeriodsSelectProps> = ({ options, value, onChange }) => {
    const { t } = useTranslation()

    const optionTemplate = (option: ISelectOption<IFairValueEvaluationPeriod>, search: string) =>
        <Flex justifyContent="space-between">
            <FlexibleContent text={option.label} highlight={search} />
            {option.value.status !== FairValueEvaluationStatus.missing &&
                <StatusLight type={periodStatusToIndicator[option.value.status]} />}
        </Flex>

    return (
        <Flex alignItems="center">
            <FlexItem shrink={0}> <Text>{t("fairValueEvaluation.bookingPeriod")}</Text></FlexItem>
            <FlexItem className='ml-2'>
                <Select
                    options={options}
                    value={value}
                    onChange={(option) => option && onChange(option?.value)}
                    optionTemplate={optionTemplate}
                    hideSelectedOptionIcon
                />
            </FlexItem>
        </Flex>
    )
}

export default BookingPeriodsSelect
